import React from 'react';
import { getOperationalMetricMeta } from '../../../constants/operationalMetricCatalog';
import { formatScalarMetricValue } from './metricFormat';
import { KpiCard, KpiLabel, KpiValue } from './styles';

/**
 * @param {{ metricKey: string, data?: { value?: number }, loading?: boolean, compact?: boolean }} props
 */
export default function ScalarMetricCard({ metricKey, data = {}, loading = false, compact = false }) {
    const { label } = getOperationalMetricMeta(metricKey);
    const display = loading ? '—' : formatScalarMetricValue(metricKey, data.value);

    if (compact) {
        return (
            <KpiCard aria-label={label}>
                <KpiLabel>{label}</KpiLabel>
                <KpiValue>{display}</KpiValue>
            </KpiCard>
        );
    }

    return <KpiValue>{display}</KpiValue>;
}
